import normal from './normal'
import disabled from './disabled'
import hidden from './hidden'
import navDark from './nav-dark'
import navLight from './nav-light'
import navWhite from './nav-white'

export default {
  normal,
  disabled,
  hidden,
  'nav-dark': navDark,
  'nav-light': navLight,
  'nav-white': navWhite
}
